module.exports = __webpack_public_path__ + "img/logo_dsvrt_white.74080a32.jpeg";